//Reset data
export const RESET = "DOSSIER_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "DOSSIER_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "DOSSIER_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "DOSSIER_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "DOSSIER_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "DOSSIER_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "DOSSIER_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "DOSSIER_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "DOSSIER_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "DOSSIER_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "DOSSIER_CREATE_SET_CREATED"
export const SET_IS_CREATED = "DOSSIER_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "DOSSIER_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "DOSSIER_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "DOSSIER_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "DOSSIER_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "DOSSIER_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "DOSSIER_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "DOSSIER_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "DOSSIER_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "DOSSIER_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "DOSSIER_CREATE_SET_MODAL_TYPE"



export const SET_CONVERSATION = "DOSSIER_CREATE_SET_CONVERSATION"
